import { GrammarCheckerErrorLogger } from '../config';
import { Category, Message } from '../types';

const CATEGORY_MAP: Record<Category, string> = {
  Orthography: 'orthography',
  Spelling: 'spelling',
  Grammar: 'grammar',
  Typos: 'typos',
  Casing: 'casing',
  Punctuation: 'punctuation',
  Noun: 'noun',
  Adjective: 'adjective',
  Verb: 'verb',
  'Noun Number': 'noun_number',
  'Subject-Verb Agreement': 'subject_verb_agreement',
  Other: 'other',
  Preposition: 'preposition',
  Pronoun: 'pronoun',
  Conjunction: 'conjunction',
  Determiner: 'determiner',
  Morphology: 'morphology',
  'Verb Tense': 'verb_tense',
  'Verb Form': 'verb_form',
  Adverb: 'adverb',
};

const MESSAGE_MAP: Record<Message, string> = {
  'Possible spelling mistake found.': 'possible_spelling_mistake_found',
  'Possible grammar mistake found.': 'possible_grammar_mistake_found',
  'Possible casing mistake found.': 'possible_casing_mistake_found',
  'Possible punctuation mistake found.': 'possible_punctuation_mistake_found',
};

const MISSING_CATEGORIES = new Set<Category>();
const MISSING_MESSAGES = new Set<Message>();

export const mapGrammarCategoryToTranslationKey = (
  category: Category,
  errorLogger?: GrammarCheckerErrorLogger,
): string => {
  if (!CATEGORY_MAP[category]) {
    if (!MISSING_CATEGORIES.has(category)) {
      MISSING_CATEGORIES.add(category);
      errorLogger?.captureMessage(`Missing category: ${category}`, 'warning');
    }
  }
  return `grammar_alerts:category.${CATEGORY_MAP[category]}`;
};

export const mapGrammarMessageToTranslationKey = (
  message: Message,
  errorLogger?: GrammarCheckerErrorLogger,
): string => {
  if (!MESSAGE_MAP[message]) {
    if (!MISSING_MESSAGES.has(message)) {
      MISSING_MESSAGES.add(message);
      errorLogger?.captureMessage(`Missing message: ${message}`, 'warning');
    }
  }
  return `grammar_alerts:message.${MESSAGE_MAP[message]}`;
};
